<template>
  <div>
    <a-menu v-model="current" mode="horizontal">
      <a-menu-item key="DeviceWarning">{{ $t('warning.device') }} </a-menu-item>
      <a-menu-item key="StationWarning">{{ $t('warning.station') }} </a-menu-item>
      <a-menu-item v-if="isMutipleShow" key="MultipleWarning">{{ $t('warning.multiple') }} </a-menu-item>
    </a-menu>
    <component :is="current[0]" />
  </div>
</template>

<script>
import DeviceWarning from './components/DeviceWarning'
import StationWarning from './components/StationWarning'
import MultipleWarning from './components/MultipleWarning.vue'

export default {
  components: {
    DeviceWarning,
    StationWarning,
    MultipleWarning
  },
  created() {
    let a = this.getAuthorities('/equipment/group')
    this.isMutipleShow = !!a.find(auth => auth.code === "warning:custom:query")
  },
  data() {
    return {
      current: ['DeviceWarning'],
      isMutipleShow: false
    }
  }
}
</script>

<style>

</style>